<template>
  <a-space>
    <span v-if="!phone">-</span>
    <template v-else>
      <template v-if="show">
        <span>{{ phone }}</span>
        <a @click="show = !show">
          <a-icon type="eye" />
        </a>
      </template>
      <template v-else>
        <span>{{ phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}</span>
        <a @click="show = !show">
          <a-icon type="eye-invisible" />
        </a>
      </template>
    </template>

  </a-space>
</template>
<script>
export default {
  name: 'show-phone',
  data() {
    return {
      show: false
    }
  },
  props: {
    phone: {
      type: String,
      default: ''
    }
  },
}
</script>